import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_HISTORY_NOTE_DETAILS,
    CLEAR_HISTORY_NOTE_DETAILS_ERROR,
    LOAD_HISTORY_NOTE_DETAILS_REQUEST,
    LOAD_HISTORY_NOTE_DETAILS_SUCCESS,
    LOAD_HISTORY_NOTE_DETAILS_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_HISTORY_NOTE_DETAILS,
    CLEAR_ERROR: CLEAR_HISTORY_NOTE_DETAILS_ERROR,
    LOAD_REQUEST: LOAD_HISTORY_NOTE_DETAILS_REQUEST,
    LOAD_SUCCESS: LOAD_HISTORY_NOTE_DETAILS_SUCCESS,
    LOAD_FAILURE: LOAD_HISTORY_NOTE_DETAILS_FAILURE
}